import { render, staticRenderFns } from "./FormAddTag.vue?vue&type=template&id=dd2535a8&scoped=true"
import script from "./FormAddTag.vue?vue&type=script&lang=js"
export * from "./FormAddTag.vue?vue&type=script&lang=js"
import style0 from "./FormAddTag.vue?vue&type=style&index=0&id=dd2535a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2535a8",
  null
  
)

export default component.exports